module.exports = __webpack_public_path__ + "static/logo-red-a71642225e09efadedc485b683a38f97.svg";